// Shared display data for Gauntlet tiers — kept in one place so the avatar badge, profile
// panel, and raid dashboard "Complete Raid" summary all agree on the same colors/labels.
export const TIER_COLORS = {
  bronze: "#B8733A",
  silver: "#C9C9C9",
  gold: "#D4AF37",
  legendary: "#D90429",
};

export const TIER_GLOW = {
  bronze: "shadow-[0_0_6px_rgba(184,115,58,0.6)]",
  silver: "shadow-[0_0_6px_rgba(201,201,201,0.6)]",
  gold: "shadow-[0_0_8px_rgba(212,175,55,0.7)]",
  legendary: "shadow-[0_0_10px_rgba(217,4,41,0.75)]",
};

export const BADGE_CORNER_CLASSES = {
  "top-left": "-top-1 -left-1",
  "top-right": "-top-1 -right-1",
  "bottom-left": "-bottom-1 -left-1",
  "bottom-right": "-bottom-1 -right-1",
};
